export enum ComponentId {
  TYPE = "type",
  POLICE_DEPARTMENT = "policeDepartment",
  CASE_NUMBER = "caseNumber",
  POLICE_IMAGES = "ocPropertyPolice",
  PERPETRATOR_IMAGES = "ocPropertyPerpetrator",
}
